import React from "react";
import DatePickerComp, { registerLocale } from "react-datepicker";
import en from "date-fns/locale/en-US";
import PropTypes from "prop-types";
import styled from "styled-components";
import "react-datepicker/dist/react-datepicker.css";
import InputAdornment from "@material-ui/core/InputAdornment";
import { Input, CalenderIcon } from ".";
import Calender from "../assets/Calendar.svg";
registerLocale("en", en);

const CustomInput = React.forwardRef(
  ({ onClick, value, placeholder, disabled, isInvalid }, ref) => (
    <div ref={ref} role="button" tabIndex={0} onClick={onClick}>
      <Input
        value={value}
        placeholder={placeholder}
        disabled={disabled}
        data-test="date-input-field"
        class={
          isInvalid
            ? "tenitive-date-input-div is-invalid"
            : "tenitive-date-input-div"
        }
        isInvalid={isInvalid}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end" className="calender-pic">
              <CalenderIcon />
            </InputAdornment>
          )
        }}
      />
    </div>
  )
);

CustomInput.propTypes = {
  onClick: PropTypes.func,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  isInvalid: PropTypes.bool
};

CustomInput.defaultProps = {
  onClick: () => {},
  value: "",
  placeholder: "",
  disabled: false,
  isInvalid: false
};

export const DatePickerCompnent = ({
  className,
  placeholder,
  disabled,
  isInvalid,
  ifValue,
  ...rest
}) => {
  console.log("datePickerResolution.js", ifValue);
  return (
    <div
      className={
        ifValue ? "tenative-issue-resolution-2" : "tenative-issue-resolution"
      }
    >
      {/* <img src={Calender} alt="Calender icon"></img> */}
      {/* {!ifValue && (
        <p
          style={{
            position: "relative",
            top: "11px",
            zIndex: 1,
            left: "8%",
            fontSize: "13px",
            cursor: "pointer !important",
            width: "116px",
            fontFamily: "mpsb",
            margin: "0px"
          }}
        >
          --DD/MM/YYYY--
        </p>
      )} */}
      <DatePickerComp
        disabled={disabled}
        placeholderText="--DD/MM/YYYY--"
        showYearDropdown
        showMonthDropdown
        locale="en"
        format={null}
        dateFormat="dd/MM/yyyy"
        customInput={
          <CustomInput
            placeholder={placeholder}
            disabled={disabled}
            isInvalid={isInvalid}
          />
        }
        {...rest}
      />
    </div>
  );
};

DatePickerCompnent.propTypes = {
  className: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  isInvalid: PropTypes.bool,
  selected: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)])
};

DatePickerCompnent.defaultProps = {
  className: "",
  placeholder: "",
  disabled: false,
  isInvalid: false,
  selected: ""
};

export const DatePicker = styled(DatePickerCompnent)`
  // .react-datepicker-wrapper {
  //   display: block;
  //   cursor: pointer;
  //   .react-datepicker__input-container {
  //     display: block;
  //     cursor: pointer;
  //   }
  //   input[type="text"] {
  //     cursor: pointer;
  //   }
  //   .react-datepicker__close-icon {
  //     right: 39px;
  //   }
  // }
  // .react-datepicker__year-option--selected,
  // .react-datepicker__month-option--selected,
  // .react-datepicker__month-year-option--selected {
  //   left: 5px;
  // }
  // .react-datepicker__month-dropdown,
  // .react-datepicker__year-dropdown {
  //   width: 100px;
  //   position: absolute !important;
  //   left: 0;
  //   top: 10px;
  // }
  // input {
  //   color: transparent;
  //   text-shadow: 0 0 0
  //     ${/* istanbul ignore next */ ({ theme }) => theme.palette.BLACK};
  // }
  // .is-invalid {
  //   div {
  //     div {
  //       z-index: 1;
  //     }
  //   }
  //   fieldset {
  //     border-color: #fc192e !important;
  //     background: #fef4f4 !important;
  //   }
  // }

  // .calender-icon {
  //   position: absolute;
  //   right: 8px;
  //   top: 8px;
  // }
`;
